import {
    ChatBubbleLeftIcon,
    EnvelopeIcon,
    MapPinIcon,
    PhoneArrowUpRightIcon,
} from "@heroicons/react/24/outline";
import { HomeCareLeadId, singleLineAddress } from "@sp-crm/core";
import { useQuery } from "@tanstack/react-query";
import { trpc } from "components/rpc/trpc";
import {
    RoundActionExternalLink,
    RoundActionLink,
} from "components/ui/round-action-button";
import { Spinner } from "components/ui/spinner";
import { computeDirectionsUrl } from "helpers/address";
import React from "react";
import { phoneUri } from "util/uri";
import { preferredEmail, preferredPhone } from "./contact-channel";

interface ClientMapContactActionsProps {
    leadId: HomeCareLeadId;
}

export const ClientMapContactActions: React.FC<ClientMapContactActionsProps> = props => {
    const { leadId } = props;
    const trpcClient = trpc.useTRPC();
    const query = useQuery(trpcClient.homeCareLead.get.queryOptions({ id: leadId }));

    const contactsLoaded = !!query.data;
    const bestContactEntity = contactsLoaded ? query.data.bestContactEntity : null;
    const selfContactEntity = contactsLoaded ? query.data.selfContactEntity : null;
    const phone = preferredPhone(bestContactEntity, selfContactEntity);
    const email = preferredEmail(bestContactEntity, selfContactEntity);
    const address = selfContactEntity ? singleLineAddress(selfContactEntity) : null;

    if (query.isLoading) {
        return <Spinner />;
    }

    return (
        <div className="flex items-center gap-1.5">
            {phone ? (
                <RoundActionLink
                    title={`Call ${phone}`}
                    Icon={PhoneArrowUpRightIcon}
                    href={phoneUri(phone)}
                />
            ) : null}
            {phone ? (
                <RoundActionLink
                    title={`Text ${phone}`}
                    Icon={ChatBubbleLeftIcon}
                    href={`sms:${phone}`}
                />
            ) : null}
            {email ? (
                <RoundActionLink
                    title={`Email ${email}`}
                    Icon={EnvelopeIcon}
                    href={`mailto:${email}`}
                />
            ) : null}
            {address ? (
                <RoundActionExternalLink
                    title="Get directions"
                    Icon={MapPinIcon}
                    href={computeDirectionsUrl(address, "")}
                />
            ) : null}
        </div>
    );
};
